export const CHINA_PAYMENT_METHODS_C2C = [
  { label: "Alipay", value: "alipay" },
  { label: "UnionPay", value: "unionpay" },
];

export const CHINA_PAYMENT_METHODS_B2B = [
  { label: "Bank Account", value: "bank_account" },
];

export const BUSINESS_TYPE_OPTIONS = [
  { label: "Business", value: "Business" },
];

export const INDIVIDUAL_TYPE_OPTIONS = [
  { label: "Individual", value: "Individual" },
];

export const B2B_PURPOSE_OPTIONS = [
  { label: "Payment for services", value: "Payment for services" },
  { label: "Payments for goods", value: "Payments for goods" },
];

export const C2C_PURPOSE_OPTIONS = [
  { label: "Personal Remittance", value: "Personal Remittance" },
];

export const CHINA_TRANSACTION_LIMITS = {
  B2B_SERVICES: 1000000,
  B2B_GOODS: 500000,
  ALIPAY: 50000,
  UNIONPAY: 50000,
  DEFAULT_MAX: 1000000,
} as const;

export const ALIPAY_RELATIONSHIPS = [
  { label: "Brothers and sisters", value: "BROTHERS_AND_SISTERS" },
  { label: "Grandchildren", value: "GRANDCHILDREN" },
  { label: "Grandparents", value: "GRANDPARENTS" },
  { label: "Grandparents-in-law", value: "GRANDPARENTS_IN_LAW" },
  { label: "Maternal grandchildren", value: "MATERNAL_GRANDCHILDREN" },
  { label: "Parents", value: "PARENTS" },
  { label: "Spouse", value: "SPOUSE" },
  { label: "Sons and daughters", value: "SONS_AND_DAUGHTERS" },
];

export const UAE_BENEFICIARY_TYPE_OPTIONS = [
  { label: "Individual", value: "Individual" },
  { label: "Business", value: "Business" },
];

export const PURPOSE_DESCRIPTION_OPTIONS = [
  { label: "Payment for services", name: "Payment for services", value: "Payment for services" },
  { label: "Payments for goods", name: "Payments for goods", value: "Payments for goods" },
  { label: "Medical treatment", name: "Medical treatment", value: "Medical treatment" },
  { label: "Advance payments for goods", name: "Advance payments for goods", value: "Advance payments for goods" },
  { label: "Vendor / contractor payouts for software development", name: "Vendor / contractor payouts for software development", value: "Vendor / contractor payouts for software development" },
  { label: "Education-related student expenses", name: "Education-related student expenses", value: "Education-related student expenses" },
];

